module.exports = __webpack_public_path__ + "img/database.a8960e87.svg";